import React from "react"

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  ariaLabel?: string
}

// Controlled checkbox using the app's shared checkbox markup/classes
// (form-control + form-control__indicator, see shared/inputs/Checkbox.jsx) so it
// matches checkboxes everywhere else. The shared component is uncontrolled, so we
// replicate its structure with a `checked` prop for table selection.
export const TableCheckbox: React.FC<Props> = ({ checked, onChange, disabled, ariaLabel }) => (
  <div className="form-inputs fsp-admin__checkbox">
    <div className="form-input form-input--no-margin check_boxes has-padding">
      <div className="form-controls">
        <div className="form-controls__controls">
          <label className="form-control">
            <input
              className="check_boxes"
              type="checkbox"
              checked={checked}
              disabled={disabled}
              aria-label={ariaLabel}
              onChange={(e) => onChange(e.target.checked)}
            />
            <span className="form-control__indicator" />
          </label>
        </div>
      </div>
    </div>
  </div>
)
